// extracted by mini-css-extract-plugin
module.exports = {"results":"Results_results__24xMo","content":"Results_content__13IRH"};